<script setup>
defineProps({
    name: String,
    id: String,
})

const model = defineModel()
</script>

<template>
    <label
        :for="id ?? name"
        dusk="comments-subscribe"
        class="relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 flex items-center"
        :class="{
            'bg-[rgba(35,41,89,1)]': !model,
            'bg-[rgba(107,96,255,1)]': model,
        }"
    >
        <span class="sr-only">Toggle</span>
        <span
            class="pointer-events-none inline-block h-3.5 w-3.5 transform rounded-full ring-0 transition ease-in-out"
            :class="{
                'translate-x-0.5 bg-[rgba(112,120,176,1)]': !model,
                'translate-x-5 bg-[rgba(233,232,255,1)]': model,
            }"
        ></span>
        <input v-model="model" type="checkbox" :name="name" :id="id ?? name" class="sr-only">
    </label>
</template>
